import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e708e05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "button-container" }

import AppButton from "@/components/atoms/button/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideItem',
  props: {
  src: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.src,
      class: "img"
    }, null, 8, _hoisted_2),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppButton, { class: "app-next-button rounded next-button" }, {
        default: _withCtx(() => [
          _createTextVNode("次へ")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})